import { getEnv, isDevelopment, isProduction } from "../utils/runtimeEnv";

/**
 * True when the GKE BFF ConfigMap sets REACT_APP_GATEWAY_URL (empty string counts).
 */
export const USE_GATEWAY_OVERRIDE = getEnv("REACT_APP_GATEWAY_URL") !== undefined;

/** Shared gateway origin for same-origin BFF or classic apis/apis-dev routing. */
export const GATEWAY_URL = USE_GATEWAY_OVERRIDE
  ? getEnv("REACT_APP_GATEWAY_URL") || ""
  : isProduction()
    ? "https://apis.risalabs.ai"
    : getEnv("REACT_APP_ENV") === "local"
      ? "http://localhost:8080"
      : getEnv("REACT_APP_ENV") === "preview"
        ? getEnv("REACT_APP_GATEWAY_URL") || ""
        : "https://apis-dev.risalabs.ai";

/**
 * Resolve a service base URL for prod/dev or same-origin BFF routing.
 *
 * @param segment - Path segment under the gateway (e.g. ``claims-service``)
 * @param productionUrl - Absolute URL when REACT_APP_ENV is production
 * @param developmentUrl - Absolute URL when REACT_APP_ENV is development
 * @returns Trailing-slash service base URL
 */
export const resolveGatewayService = (
  segment: string,
  productionUrl: string,
  developmentUrl: string,
): string => {
  if (USE_GATEWAY_OVERRIDE) {
    return segment === "" ? `${GATEWAY_URL}/` : `${GATEWAY_URL}/${segment}/`;
  }
  if (isProduction()) {
    return productionUrl;
  }
  if (isDevelopment()) {
    return developmentUrl;
  }
  return segment === "" ? `${GATEWAY_URL}/` : `${GATEWAY_URL}/${segment}/`;
};

/**
 * Resolve auth-service user-auth base for prod/dev or same-origin BFF routing.
 *
 * @returns Base URL for auth user-auth endpoints
 */
export const resolveAuthUserUrl = (): string => {
  if (USE_GATEWAY_OVERRIDE) {
    return `${GATEWAY_URL}/api/v1/user-auth`;
  }
  if (isProduction() || isDevelopment()) {
    return "https://authentication.risalabs.ai/api/v1/user-auth";
  }
  return `${GATEWAY_URL}/api/v1/user-auth`;
};

/**
 * Resolve RPA gateway origin for prod/dev or same-origin BFF routing.
 *
 * @returns RPA gateway base without trailing service path
 */
export const resolveRpaGateway = (): string => {
  if (USE_GATEWAY_OVERRIDE) {
    return GATEWAY_URL;
  }
  if (isProduction()) {
    return "https://api.risalabs.ai";
  }
  if (isDevelopment()) {
    return "https://api-dev.risalabs.ai";
  }
  return GATEWAY_URL;
};
